module.exports = __webpack_public_path__ + "img/m_contents_drive@2x.89f1a7bc.png";